// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "sgp/" + ({"89":"Logout","90":"Customers","103":"PostSales","120":"Contacts","167":"PageNotFound","198":"Applications","258":"News","264":"Campaigns","286":"Overview","308":"MyProfile","320":"Authorize","392":"GenericErrorHandler","616":"Library","808":"OdsAgentTest","987":"LoginChoice"}[chunkId] || chunkId) + ".css";
};